export default {
  mainPageNotices: [],
  notices: [],
  noticeCount: 0,
  notice: {}
}